export const DATE_TIME_FORMAT_MAP = {
    YEAR_DATE_TIME: 'YYYY/M/D(dd) HH:mm',
    YEAR_DATE_TIME_WITHOUT_DAY: 'YYYY-MM-DD HH:mm',
    YEAR_DATE: 'YYYY/M/D(dd)',
    YEAR_DATE_WITHOUT_DAY: 'YYYY/M/D',
    YEAR_MONTH: 'YYYY/MM',
    DATE_TIME: 'M/D (dd) HH:mm',
    DATE_TIME_WITHOUT_DAY: 'M/D HH:mm',
    DATE: 'M/D (dd)',
    DATE_WITHOUT_DAY: 'M/D',
    TIME: 'HH:mm',
    HOUR: 'HH',
    MINUTE: 'mm',
    CCV: 'MM / YY',
    COMMENT: 'YYYY年M月',
};
export const DAYJS_LOCALE = 'zh-tw';
